import React, { useState } from 'react';
import { useAuthStore } from '../store';
import { translations } from '../translations';

// Datos simulados de usuario Caldea
const mockUser = {
  name: 'María García',
  membership: 'Club Caldea Premium',
  improvementLevel: 125,
  streak: 8,
  weeklyVisits: 3,
  monthlyGoal: 12,
  monthlyProgress: 9,
  avatar: '👩'
};

// Recompensas disponibles para canjear
const availableRewards = [
  {
    id: 1,
    name: 'Sesión Descontracturante',
    category: 'RECOVERY',
    improvementCost: 15,
    available: true,
    description: 'Descarga muscular post-entreno de 20 min',
    valleyHours: '10:00-14:00',
    icon: '💆'
  },
  {
    id: 2,
    name: 'Upgrade Circuito Recovery',
    category: 'RECOVERY',
    improvementCost: 20,
    available: true,
    description: 'Sauna + Relax + Baños de contraste',
    valleyHours: '11:00-15:00',
    icon: '🧖'
  },
  {
    id: 3,
    name: 'Breathwork Guiado',
    category: 'EMOTIONAL',
    improvementCost: 10,
    available: true,
    description: 'Sesión de respiración 15 min en zona relax',
    valleyHours: 'Todo el día',
    icon: '🧘'
  },
  {
    id: 4,
    name: 'Hidratación Wellness',
    category: 'WELLNESS',
    improvementCost: 5,
    available: true,
    description: 'Infusión o bebida saludable de la carta',
    valleyHours: 'Todo el día',
    icon: '🍵'
  },
  {
    id: 5,
    name: 'Quiet Hour Premium',
    category: 'EMOTIONAL',
    improvementCost: 30,
    available: false,
    description: 'Hora exclusiva en zona relax VIP',
    valleyHours: '14:00-16:00',
    icon: '✨',
    unlockAt: 150
  }
];

// Historial de canjes
const redemptionHistory = [
  { id: 1, reward: 'Hidratación Wellness', date: '2026-01-25', improvementCost: 5, trigger: 'Racha 3 días' },
  { id: 2, reward: 'Breathwork Guiado', date: '2026-01-23', improvementCost: 10, trigger: 'HRV bajo detectado' },
  { id: 3, reward: 'Sesión Descontracturante', date: '2026-01-20', improvementCost: 15, trigger: '4.8km cardio' },
  { id: 4, reward: 'Upgrade Circuito Recovery', date: '2026-01-18', improvementCost: 20, trigger: '55min fuerza' },
];

// Triggers activos del usuario
const activeTriggers = [
  { type: 'CARDIO', label: '5.2 km hoy', eligible: 'Sesión Descontracturante', ready: true },
  { type: 'STREAK', label: 'Racha 8 días 🔥', eligible: 'Hidratación Wellness', ready: true },
  { type: 'GOAL', label: '9/12 sesiones mes', eligible: 'Quiet Hour (3 más)', ready: false }
];

const categoryColors = {
  RECOVERY: { bg: 'bg-blue-100 dark:bg-blue-900/40', text: 'text-blue-700 dark:text-blue-300', border: 'border-blue-500' },
  EMOTIONAL: { bg: 'bg-purple-100 dark:bg-purple-900/40', text: 'text-purple-700 dark:text-purple-300', border: 'border-purple-500' },
  WELLNESS: { bg: 'bg-green-100 dark:bg-green-900/40', text: 'text-green-700 dark:text-green-300', border: 'border-green-500' }
};

export default function RewardsPage() {
  const [selectedReward, setSelectedReward] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [activeTab, setActiveTab] = useState('available');
  const { language } = useAuthStore();
  const t = translations[language];

  const handleRedeem = (reward) => {
    setSelectedReward(reward);
    setShowConfirmModal(true);
  };

  const confirmRedeem = () => {
    // Simular canje exitoso
    setShowConfirmModal(false);
    alert(`¡Canjeado! Presenta este código en recepción: CALDEA-${Date.now().toString(36).toUpperCase()}`);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-8 dark:text-gray-100">
      {/* Header con puntos y estado */}
      <div className="bg-gradient-to-r from-cyan-600 to-blue-700 dark:from-cyan-800 dark:to-blue-900 rounded-2xl p-6 mb-8 text-white">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div>
            <h1 className="text-3xl font-bold mb-2">{t.rewardsTitle}</h1>
            <p className="text-cyan-100">{t.rewardsSubtitle}</p>
          </div>
          <div className="flex gap-6">
            <div className="text-center">
              <div className="text-4xl font-bold">{mockUser.improvementLevel}</div>
              <div className="text-sm text-cyan-100">{t.improvementLevel}</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold">🔥 {mockUser.streak}</div>
              <div className="text-sm text-cyan-100">{t.streak}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Triggers activos */}
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6 mb-8">
        <h2 className="text-xl font-bold mb-4 flex items-center gap-2 dark:text-white">
          {t.activeTriggers}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {activeTriggers.map((trigger, index) => (
            <div 
              key={index} 
              className={`p-4 rounded-lg border-2 ${trigger.ready ? 'border-green-500 bg-green-50 dark:bg-green-900/20' : 'border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700'}`}
            >
              <div className="flex justify-between items-start mb-2">
                <span className="font-semibold dark:text-gray-200">{trigger.label}</span>
                {trigger.ready && (
                  <span className="bg-green-500 text-white text-xs px-2 py-1 rounded-full">{t.ready}</span>
                )}
              </div>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                {trigger.ready ? '→' : '⏳'} {trigger.eligible}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Tabs */}
      <div className="flex gap-4 mb-6 border-b dark:border-gray-700">
        <button 
          className={`pb-3 px-4 font-semibold ${activeTab === 'available' ? 'border-b-2 border-cyan-600 text-cyan-600 dark:text-cyan-400 dark:border-cyan-400' : 'text-gray-500 dark:text-gray-400'}`}
          onClick={() => setActiveTab('available')}
        >
          {t.tabAvailableRewards}
        </button>
        <button 
          className={`pb-3 px-4 font-semibold ${activeTab === 'history' ? 'border-b-2 border-cyan-600 text-cyan-600 dark:text-cyan-400 dark:border-cyan-400' : 'text-gray-500 dark:text-gray-400'}`}
          onClick={() => setActiveTab('history')}
        >
          {t.tabHistory}
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === 'available' && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {availableRewards.map((reward) => {
            const colors = categoryColors[reward.category];
            const canAfford = mockUser.improvementLevel >= reward.improvementCost;
            const isLocked = !reward.available;
            
            return (
              <div 
                key={reward.id} 
                className={`bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden ${isLocked ? 'opacity-60' : ''}`}
              >
                <div className={`${colors.bg} p-4 flex justify-between items-center`}>
                  <span className="text-4xl">{reward.icon}</span>
                  <span className={`${colors.text} px-3 py-1 rounded-full text-sm font-semibold border ${colors.border}`}>
                    {reward.category}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="text-lg font-bold mb-2 dark:text-white">{reward.name}</h3>
                  <p className="text-gray-600 dark:text-gray-300 text-sm mb-3">{reward.description}</p>
                  
                  <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400 mb-4">
                    <span>🕐</span>
                    <span>{t.valleyHours} {reward.valleyHours}</span>
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="flex items-center gap-1">
                      <span className="text-xl font-bold text-cyan-600 dark:text-cyan-400">{reward.improvementCost} {t.improvementCost}</span>
                    </div>
                    
                    {isLocked ? (
                      <span className="text-sm text-gray-500">
                        🔒 Desbloquea a {reward.unlockAt} Instancias
                      </span>
                    ) : canAfford ? (
                      <button 
                        onClick={() => handleRedeem(reward)}
                        className="bg-cyan-600 text-white px-4 py-2 rounded-lg font-semibold hover:bg-cyan-700 transition"
                      >
                        Canjear
                      </button>
                    ) : (
                      <span className="text-sm text-gray-500">
                        {reward.improvementCost} Instancias requeridas
                      </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {activeTab === 'history' && (
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <table className="w-full">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-6 py-4 text-left text-sm font-semibold">Recompensa</th>
                <th className="px-6 py-4 text-left text-sm font-semibold">Trigger</th>
                <th className="px-6 py-4 text-left text-sm font-semibold">Coste Instancias</th>
                <th className="px-6 py-4 text-left text-sm font-semibold">Fecha</th>
              </tr>
            </thead>
            <tbody>
              {redemptionHistory.map((item) => (
                <tr key={item.id} className="border-t hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium">{item.reward}</td>
                  <td className="px-6 py-4">
                    <span className="bg-cyan-100 text-cyan-700 px-3 py-1 rounded-full text-sm">
                      {item.trigger}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-cyan-600 font-semibold">{item.improvementCost} Instancias</td>
                  <td className="px-6 py-4 text-gray-500">{item.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal de confirmación */}
      {showConfirmModal && selectedReward && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4">
            <div className="text-center mb-6">
              <span className="text-6xl">{selectedReward.icon}</span>
            </div>
            <h3 className="text-2xl font-bold text-center mb-2">¿Confirmar canje?</h3>
            <p className="text-center text-gray-600 mb-6">
              Vas a canjear <strong>{selectedReward.name}</strong> por <strong>{selectedReward.improvementCost} instancias</strong>
            </p>
            <p className="text-center text-sm text-gray-500 mb-6">
              🕐 Válido en horario: {selectedReward.valleyHours}
            </p>
            <div className="flex gap-4">
              <button 
                onClick={() => setShowConfirmModal(false)}
                className="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-300 transition"
              >
                Cancelar
              </button>
              <button 
                onClick={confirmRedeem}
                className="flex-1 bg-cyan-600 text-white py-3 rounded-lg font-semibold hover:bg-cyan-700 transition"
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
